import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { VideoStyle } from '@website-builder/widgets/video/model/video-style';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class VideoWidget extends BaseWidget<VideoStyle> {
  readonly type = BuilderElementType.Video;
  style = new VideoStyle();
  link = '';
  width: number;
  height: number;
  showControls = true;
  loopVideo: boolean;
  muteVideo: boolean;
  autoplay = 'off';
  posterFrame = '';

  static normalizeInPlace(widget: VideoWidget): VideoWidget {
    const pureWidget = new VideoWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.link = widget.link ?? pureWidget.link;
    widget.width = widget.width ?? pureWidget.width;
    widget.height = widget.height ?? pureWidget.height;
    widget.showControls = widget.showControls ?? pureWidget.showControls;
    widget.loopVideo = widget.loopVideo ?? pureWidget.loopVideo;
    widget.muteVideo = widget.muteVideo ?? pureWidget.muteVideo;
    widget.autoplay = widget.autoplay ?? pureWidget.autoplay;
    widget.posterFrame = widget.posterFrame ?? pureWidget.posterFrame;

    widget.style = VideoStyle.normalize(widget.style);

    return widget;
  }
}
